import React from 'react';
import PropTypes from 'prop-types';
import { ThreadToggleUnreadButton } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleUnreadButton';
import { ThreadToggleStarredButton } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleStarredButton';
import { ThreadToggleArchivedButton } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleArchivedButton';
import fr from 'facet-rest';
import ThreadMemberNavigationLinksButton
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadMemberNavigationLinksButton';

const DesktopThreadQuickActions = ({
  threadResource,
  size,
  color,
  enableMemberNavigationLinks,
  memberThreadParticipant,
}) => {
  return (
    <React.Fragment>
      {enableMemberNavigationLinks && memberThreadParticipant && (
        <ThreadMemberNavigationLinksButton
          color={color}
          size={'default'}
          memberThreadParticipant={memberThreadParticipant}
        />
      )}
      <ThreadToggleUnreadButton
        resource={threadResource}
        color={color}
        size={size}
      />
      <ThreadToggleStarredButton
        resource={threadResource}
        color={color}
        size={size}
      />
      <ThreadToggleArchivedButton
        resource={threadResource}
        color={color}
        size={size}
      />
    </React.Fragment>
  );
};

DesktopThreadQuickActions.defaultProps = {
  size: 'default',
  color: 'actionActive',
  enableMemberNavigationLinks: false,
  memberThreadParticipant: undefined,
};

DesktopThreadQuickActions.propTypes = {
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
  memberThreadParticipant: PropTypes.instanceOf(fr.Resource),
  size: PropTypes.string,
  color: PropTypes.string,
  enableMemberNavigationLinks: PropTypes.bool,
};

export { DesktopThreadQuickActions };
